import { LayerGroupIds } from "fond/layers";
import type { MultiLayerUploadSection } from "fond/project/panels/InputPanel/MultiLayerUploadForm";
import { LayerIds } from "fond/types";

import { BaseDataLayerKey } from "../layers";

/** Input layer group used to upload, area select and draw each base data layer; the boundary has none. */
export const BASE_DATA_LAYER_GROUP_IDS: Record<Exclude<BaseDataLayerKey, "boundary">, keyof typeof LayerGroupIds> = {
  addresses: "inAddress",
  parcels: "inParcel",
  streets: "inBaseDataStreet",
  ug: "inUnderground",
  aerial: "spanPole",
  leadins: "inLeadIns",
  sources: "inExchange",
};

/** Base data layers uploaded one planner layer at a time rather than through their layer group. */
export const MULTI_LAYER_UPLOAD_SECTIONS: Partial<Record<BaseDataLayerKey, MultiLayerUploadSection[]>> = {
  ug: [
    { layerId: LayerIds.inStreet, displayName: "Underground path", geometryType: "LineString" },
    { layerId: LayerIds.inStreetPoints, displayName: "Underground points", geometryType: "Point" },
  ],
  aerial: [
    { layerId: LayerIds.inSpan, displayName: "Aerial spans", geometryType: "LineString" },
    { layerId: LayerIds.inPole, displayName: "Poles", geometryType: "Point" },
  ],
};

/** Return the input layer group of a base data layer, or null for the boundary. */
export const getBaseDataLayerGroupId = (key: BaseDataLayerKey): keyof typeof LayerGroupIds | null =>
  key === "boundary" ? null : BASE_DATA_LAYER_GROUP_IDS[key];
